import React, { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import CallImg from "../assets/images/contact/call.svg";
import EmailImg from "../assets/images/contact/mail.svg";
import WebImg from "../assets/images/contact/web.svg";
import HeadingLines from "../assets/images/heading-lines.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  createContactInquiry,
  clearMessages,
} from "../features/visitor/visitorActions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify"; // Import toast
import { formatPhoneNumber } from "../helpers/helpers";

function GetInTouch({ data }) {
  const [contactUsData, setContactUsData] = useState(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const { loading, successMessage, errorMessage } = useSelector(
    (state) => state.visitor
  );

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    setPhone(formatPhoneNumber(value));
  };

  const validate = () => {
    const errors = {};

    // Check for empty fields
    if (!fullName) errors.fullName = "Full Name is required.";
    if (!email) errors.email = "Email is required.";
    if (!phone) errors.phone = "Phone Number is required.";
    if (!description) errors.description = "Description is required.";

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email))
      errors.email = "Invalid email format.";

    if (phone && phone.length !== 12)
      errors.phone = "Please enter valid phone number.";

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Initial blank errors
    setErrors({});

    // Validate form inputs
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Dismiss any currently visible toasts
    toast.dismiss();

    // Dispatch registration action
    let data = {
      name: fullName,
      email: email,
      mobile_number: phone,
      description: description,
    };

    dispatch(createContactInquiry(data));
  };

  // Show success and error toasts
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, { autoClose: 3000, hideProgressBar: true });
      dispatch(clearMessages()); // Reset the messages after showing the toast
      setFullName("");
      setEmail("");
      setPhone("");
      setDescription("");
      setErrors({});
    }
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
      dispatch(clearMessages()); // Reset the messages after showing the toast
    }
  }, [successMessage, errorMessage, dispatch]);

  useEffect(() => {
    if (data) {
      setContactUsData(data);
    }
  }, [data]);

  return (
    <>
      <section className="get-in-touch">
        <Container>
          <Row>
            <Col md="12">
              <div className="common-header">
                <img src={HeadingLines} alt="" />
                <h2>{contactUsData?.title}</h2>
                <p>{contactUsData?.description}</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm="12" lg="6" className="mb-4 mb-lg-0">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3 form-group">
                  <Form.Label>
                    Full Name <span>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Full Name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    isInvalid={!!errors.fullName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.fullName}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  className="mb-3 form-group"
                  controlId="formBasicEmail"
                >
                  <Form.Label>
                    Email Address <span>*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>{" "}
                </Form.Group>
                <Form.Group className="mb-3 form-group">
                  <Form.Label>
                    Phone Number <span>*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Phone Number"
                    maxLength={12}
                    value={phone}
                    onChange={handlePhoneChange}
                    //onChange={(e) => setPhone(e.target.value)}
                    isInvalid={!!errors.phone}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phone}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 form-group w-full">
                  <Form.Label>
                    Description <span>*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Write here..."
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    isInvalid={!!errors.description}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.description}
                  </Form.Control.Feedback>
                </Form.Group>

                <Button
                  className="custom-bttn next-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      size="lg"
                      className="spinner-icon"
                    />
                  ) : (
                    <>
                      Submit
                    </>
                  )}
                </Button>
              </Form>
            </Col>
            <Col sm="12" lg="6">
              <div className="get-in-touch-box">
                <div className="get-in-touch-list">
                  <div className="get-in-touch-img">
                    <img src={CallImg} alt="" />
                  </div>
                  <div className="get-in-touch-list-text">
                    <h3>Call Us</h3>
                    <p>{contactUsData?.call_us_title}</p>
                    <a
                      href={`tel:${contactUsData?.call_us_no}`}
                      className="phone-number"
                    >
                      {contactUsData?.call_us_no}
                    </a>
                    <span>{contactUsData?.call_us_time}</span>
                  </div>
                </div>
                <div className="get-in-touch-list">
                  <div className="get-in-touch-img">
                    <img src={EmailImg} alt="" />
                  </div>
                  <div className="get-in-touch-list-text">
                    <h3>Send Us an Email</h3>
                    <p>{contactUsData?.email_us_title}</p>
                    <a href={`mailto:${contactUsData?.email_us_no}`} title="">
                      {contactUsData?.email_us_no}
                    </a>
                  </div>
                </div>
                <div className="get-in-touch-list">
                  <div className="get-in-touch-img">
                    <img src={WebImg} alt="" />
                  </div>
                  <div className="get-in-touch-list-text for-inquiries">
                    <h3>For Inquiries</h3>
                    <p>{contactUsData?.inquiries_title}</p>
                    <a href={`tel:${contactUsData?.inquiries_no}`}>
                      {contactUsData?.inquiries_no}
                    </a>
                    <a href={`mailto:${contactUsData?.inquiries_email}`}>
                      {contactUsData?.inquiries_email}
                    </a>

                    <p className="pt-3">
                      <b>{contactUsData?.inquiries_international_title}</b>
                    </p>
                    <p className="mb-0">
                      <a
                        href={`tel:${contactUsData?.inquiries_international_no}`}
                      >
                        {contactUsData?.inquiries_international_no}
                      </a>
                    </p>
                    <p>
                      <a
                        href={`mailto:${contactUsData?.inquiries_international_email}`}
                      >
                        {contactUsData?.inquiries_international_email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default GetInTouch;
